const sliderSettings = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  customPaging: (index) => {
    const dots = document.querySelectorAll('.slick-dots li');
    let isActive = false;

    if (dots && dots[index]) {
      isActive = dots[index].classList.contains('slick-active');
    }

    return (
      <div
        style={{
          width: '10px',
          height: '10px',
          background: isActive ? 'white' : 'rgba(255, 255, 255, 0.5)',
          borderRadius: '50%',
          display: 'inline-block',
          margin: '0 0 25px 0',
        }}
      />
    );
  },
  dotsClass: 'slick-dots custom-dots',
};

export default sliderSettings;
